











import { Component, Vue, Prop } from "vue-property-decorator";
import WithdrawTypeSelect from "../withdraw/WithdrawTypeSelect.vue";

const events = {
  send: Symbol("send"),
  receive: Symbol("receive"),
  exchange: Symbol("exchange"),
  loan: Symbol("loan"),
  otc: Symbol("otc"),
  regularInvest: Symbol("regular-invest")
};

@Component({
  components: {
    WithdrawTypeSelect
  }
})
class Actions extends Vue {
  @Prop() asset;

  get actions() {
    // const config = this.$store.state.app.config;
    const actions: any = [
      {
        text: this.$t("common.send"),
        event: events.send,
        icon: this.$icons.mdiArrowUp,
        size: "26",
        color: "#F50000"
      },
      // {
      //   text: this.$t("common.receive"),
      //   event: events.receive,
      //   icon: this.$icons.mdiArrowDown,
      //   size: "26",
      //   color: "#009621"
      // },
      {
        text: this.$t("common.exchange"),
        event: events.exchange,
        icon: "$vuetify.icons.iconSwitch",
        size: "16"
      }
    ];
    // if (config.c2c) {
    //   actions.push({
    //     text: this.$t("common.otc"),
    //     event: events.otc,
    //     icon: "$vuetify.icons.iconOtc"
    //   });
    // }
    return actions;
  }

  get symbol() {
    return (this.asset && this.asset.symbol) || "";
  }

  handleActionClick(action) {
    switch (action.event) {
      case events.send:
        this.handleSend();
        break;
      case events.receive:
        this.handleReceive();
        break;
      case events.exchange:
        this.handleExchange();
        break;
      case events.regularInvest:
        this.handleRegularInvest();
        break;
      case events.otc:
        this.handleToOTC();
        break;
    }
  }

  handleSend() {
    const typeRef = this.$refs["withdrawTypeSelect"] as any;
    typeRef.show(this.asset.asset_id);
  }

  handleReceive() {
    this.$helper.toFusionPath(this, "wallet", {
      name: "deposit",
      query: { id: this.asset.asset_id }
    });
  }

  handleExchange() {
    this.$common.utils.helper.toFusionPath(this, "trade", {
      name: "atm",
      query: {
        wanted: this.asset.asset_id
      }
    });
  }

  handleRegularInvest() {
    this.$common.utils.helper.toFusionPath(this, "hfox", {
      name: "index"
    });
  }

  handleToOTC() {
    this.$common.utils.helper.toFusionPath(this, "trade", {
      name: "fiat",
      query: {
        wanted: this.asset.symbol
      }
    });
  }
}
export default Actions;
